import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles.css';
import App from './app';  // Correct case to match file name

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);